<button mat-stroked-button color="primary" [color]="color">
    <mat-icon svgIcon="add_icon" />
    {{ captionInternal }}
</button>
